import _Object$values from "@babel/runtime-corejs2/core-js/object/values";

/* Effectively an enum, but older versions of TypeScript
would then require always using an enum reference instead
of a perfectly valid literal value:
> Type '"settings"' is not assignable to type 'IconName | undefined'
I think we could use an enum if we and all consumers
upgraded to TypeScript 4.1+, but this is safe for now. */

/** map of available icon names */
export var IconName = {
  Add: 'add',
  AddOutline: 'add-outline',
  AddSolid: 'add-solid',
  Alert: 'alert',
  ApmOutline: 'apm-outline',
  AppSwitcher: 'app-switcher',
  Archive: 'archive',
  ArrowDown: 'arrow-down',
  ArrowLeft: 'arrow-left',
  ArrowRight: 'arrow-right',
  ArrowUp: 'arrow-up',
  ArrowsUpDown: 'arrows-up-down',
  BackwardOutline: 'backward-outline',
  BackwardSolid: 'backward-solid',
  Beta: 'beta',
  BookmarkOutline: 'bookmark-outline',
  BookmarkSolid: 'bookmark-solid',
  BookmarkStarredOutline: 'bookmark-starred-outline',
  BookmarkStarredSolid: 'bookmark-starred-solid',
  Cache: 'cache',
  Calendar: 'calendar',
  CaretBottomRight: 'caret-bottom-right',
  CaretDown: 'caret-down',
  CaretLeft: 'caret-left',
  CaretRight: 'caret-right',
  CaretUp: 'caret-up',
  ChartLine: 'chart-line',
  ChartReport: 'chart-report',
  Chat: 'chat',
  Check: 'check',
  CheckOutline: 'check-outline',
  CheckSolid: 'check-solid',
  ChevronDown: 'chevron-down',
  ChevronDownOutline: 'chevron-down-outline',
  ChevronDownSolid: 'chevron-down-solid',
  ChevronLeft: 'chevron-left',
  ChevronLeftOutline: 'chevron-left-outline',
  ChevronLeftSolid: 'chevron-left-solid',
  ChevronRight: 'chevron-right',
  ChevronRightOutline: 'chevron-right-outline',
  ChevronRightSolid: 'chevron-right-solid',
  ChevronUp: 'chevron-up',
  ChevronUpOutline: 'chevron-up-outline',
  ChevronUpSolid: 'chevron-up-solid',
  Circle: 'circle',
  Clipboard: 'clipboard',
  Clock: 'clock',
  Close: 'close',
  CloseOutline: 'close-outline',
  CloseSolid: 'close-solid',
  Code: 'code',
  Collapse: 'collapse',
  CollapseAlt: 'collapse-alt',
  Console: 'console',
  Dashboard: 'dashboard',
  Database: 'database',
  Debug: 'debug',
  Delete: 'delete',
  DerivedField: 'derived-field',
  Desktop: 'desktop',
  Disabled: 'disabled',
  Document: 'document',
  DocumentBars: 'document-bars',
  Download: 'download',
  Drag: 'drag',
  Dropdown: 'dropdown',
  Edit: 'edit',
  Email: 'email',
  Error: 'error',
  ErrorOutline: 'error-outline',
  ErrorSolid: 'error-solid',
  Expand: 'expand',
  ExpandAlt: 'expand-alt',
  Export: 'export',
  ExternalLink: 'external-link',
  ExternalLinkSmall: 'external-link-small',
  Eye: 'eye',
  Filter: 'filter',
  Folder: 'folder',
  ForwardOutline: 'forward-outline',
  ForwardSolid: 'forward-solid',
  Grid: 'grid',
  GridAlt: 'grid-alt',
  HelpOutline: 'help-outline',
  HelpSolid: 'help-solid',
  History: 'history',
  Home: 'home',
  Hosts: 'hosts',
  InfoOutline: 'info-outline',
  InfoSolid: 'info-solid',
  Integrations: 'integrations',
  Link: 'link',
  List: 'list',
  ListAlt: 'list-alt',
  Location: 'location',
  LocationSolid: 'location-solid',
  Locked: 'locked',
  Maintenance: 'maintenance',
  Map: 'map',
  Menu: 'menu',
  More: 'more',
  MoreAlt: 'more-alt',
  Organization: 'organization',
  Pagespeed: 'pagespeed',
  PauseOutline: 'pause-outline',
  PauseSolid: 'pause-solid',
  Placeholder: 'placeholder',
  PlayOutline: 'play-outline',
  PlaySolid: 'play-solid',
  Refresh: 'refresh',
  Remove: 'remove',
  RemoveOutline: 'remove-outline',
  RemoveSolid: 'remove-solid',
  Rum: 'rum',
  Search: 'search',
  SearchLogs: 'search-logs',
  Server: 'server',
  Settings: 'settings',
  Share: 'share',
  ShareAlt: 'share-alt',
  Shortcuts: 'shortcuts',
  SourceSetup: 'source-setup',
  Square: 'square',
  Stack: 'stack',
  StarOutline: 'star-outline',
  StarSolid: 'star-solid',
  StopOutline: 'stop-outline',
  StopSolid: 'stop-solid',
  SubscriptionOutline: 'subscription-outline',
  Swi: 'swi',
  Tag: 'tag',
  Target: 'target',
  ToBottom: 'to-bottom',
  ToLeft: 'to-left',
  ToRight: 'to-right',
  ToTop: 'to-top',
  Transaction: 'transaction',
  TurnOff: 'turn-off',
  Unlocked: 'unlocked',
  Uptime: 'uptime',
  User: 'user',
  Users: 'users',
  WarningOutline: 'warning-outline',
  WarningSolid: 'warning-solid',
  Website: 'website',
  ZoomIn: 'zoom-in',
  ZoomOut: 'zoom-out'
};
/** available icon names */

/** array of available icon names */
export default _Object$values(IconName);